export default "__VITE_ASSET__DkWUA_7x__"